import createSanityClient, { type SanityClient } from '@sanity/client'

let client: SanityClient | null = null
let initAttempted = false

export function getSanityClient(): SanityClient | null {
  if (client) return client
  if (initAttempted) return null

  initAttempted = true

  const projectId = import.meta.env.VITE_SANITY_PROJECT_ID
  const dataset = import.meta.env.VITE_SANITY_DATASET
  const apiVersion = import.meta.env.VITE_SANITY_API_VERSION || '2025-01-01'

  if (!projectId || !dataset) {
    return null
  }

  try {
    client = createSanityClient({
      projectId,
      dataset,
      apiVersion,
      useCdn: true,
    })
    return client
  } catch (error) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn('[SANITY] Failed to initialize client', error)
    }
    client = null
    return null
  }
}

